import React from 'react'
import { useLanguage } from '../../hooks/useLanguage'
import { StaticImage } from 'gatsby-plugin-image'
import ProContactForm from './ProContactForm'

const ProContact = () => {

  const { lang } = useLanguage()

  return (
    <div className='bg-white flex-col gap-8 flex lg:flex-row' id='contact-form'>
      <div className='flex-col lg:flex-row py-10 lg:py-0 px-2 gap-8 lg:w-1/2'>
        <div>
          <p className='lg:text-xl text-center text-[#333] leading-170'>お気軽にお問い合わせください！</p>
          <div className='flex gap-2 items-center pt-6 justify-center'>
            <StaticImage src='../../img/pro/phone.png' alt='電話番号' className='w-12' loading='lazy' />
            <a href='tel:050-5806-6840' className='text-lg lg:text-[32px] font-medium text-left text-[#333] hover:text-[#33b2a4] active:text-[#333]'>
              050-5806-6840
            </a>
          </div>
          <div className='flex gap-2 items-center pb-6 lg:pb-8 justify-center lg:pt-2'>
            <svg width='51' height='50' viewBox='0 0 51 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <g filter='url(#filter0_d_2144_1371)'>
                <path d='M5.18164 16.1667C5.18164 15.0616 5.62063 14.0018 6.40203 13.2204C7.18343 12.439 8.24324 12 9.34831 12H42.6816C43.7867 12 44.8465 12.439 45.6279 13.2204C46.4093 14.0018 46.8483 15.0616 46.8483 16.1667V41.1667C46.8483 42.2717 46.4093 43.3315 45.6279 44.1129C44.8465 44.8943 43.7867 45.3333 42.6816 45.3333H9.34831C8.24324 45.3333 7.18343 44.8943 6.40203 44.1129C5.62063 43.3315 5.18164 42.2717 5.18164 41.1667V16.1667ZM12.5129 16.1667L26.015 27.9812L39.5171 16.1667H12.5129ZM42.6816 18.9354L27.3879 32.3188C27.008 32.6516 26.5201 32.8351 26.015 32.8351C25.5099 32.8351 25.022 32.6516 24.6421 32.3188L9.34831 18.9354V41.1667H42.6816V18.9354Z' fill='#333333' />
              </g>
              <defs>
                <filter id='filter0_d_2144_1371' x='-3.81836' y='0' width='54' height='54' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
                  <feFlood floodOpacity='0' result='BackgroundImageFix' />
                  <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                  <feOffset dx='-4' dy='4' />
                  <feColorMatrix type='matrix' values='0 0 0 0 0.988235 0 0 0 0 0.976471 0 0 0 0 0.666667 0 0 0 1 0' />
                  <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_2144_1371' />
                  <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_2144_1371' result='shape' />
                </filter>
              </defs>
            </svg>
            <a href='mailto:hello@1f8.dev' className='text-lg lg:text-[32px] font-medium text-left text-[#333] hover:text-[#33b2a4] active:text-[#333]'>
              hello@1f8.dev
            </a>
          </div>
          <div className='w-7/12 mx-auto'>
            <StaticImage src='../../img/pro/contact.webp' alt='メールを送る人' loading='lazy' />
          </div>
        </div>
      </div>
      <ProContactForm />
    </div>
  )
}

export default ProContact